var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--ncap-300)",
    fillRule: "evenodd",
    d: "M33 12a6 6 0 0 0-6 6v9h18v-9a6 6 0 0 0-6-6h-6Zm18 15v-9A12 12 0 0 0 39 6h-6a12 12 0 0 0-12 12v9h-3c-5 0-9 4-9 9v18c0 5 4 9 9 9h36c5 0 9-4 9-9V36c0-5-4-9-9-9h-3Zm-33 6a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h36a3 3 0 0 0 3-3V36a3 3 0 0 0-3-3H18Zm18 6a3 3 0 0 1 3 3v6a3 3 0 1 1-6 0v-6a3 3 0 0 1 3-3Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.2c3c4908f0530c480a8955e2419aa776.svg";
export { ForwardRef as ReactComponent };